import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import classes from './SubjectUDCCard.module.css';

const SubjectUDCCard = props => {
  console.log('🚀 ~ SubjectUDCCard ~ props:', props);
  return (
    <div className={classes.cardContainer}>
      <div className={classes.generalSubjectInfo}>
        <aside
          className={`${classes.subjectIconContainerStudent} ${
            !props.archived
              ? classes.activeSubject
              : classes.archiveSubject
          }`}
        >
          <figure className={classes.subjectIconStudent}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/alumno.png"
              alt=""
            />
          </figure>
        </aside>
        <aside className={classes.infoContainer}>
          <p className={classes.title}>{props.classroomData.name}</p>
          <p className={classes.description}>
            {props.classroomData.description.split('|')[1]}
          </p>
          {!props.archived ? (
            <p className={classes.description}>
              Fecha: {props.classroomData.description.split('|')[0]}
            </p>
          ) : (
            <p className={classes.description}>
              Fecha de archivado:{' '}
              {new Date(
                props.classroomData.updateTime
              ).toLocaleDateString('es-MX', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
          )}
        </aside>
      </div>
      <div className={classes.iconsContainer}>
        <div className={props.archived && classes.iconsArchived}>
          <Button
            href={props.classroomData.alternateLink}
            target="_blank"
            componnt="a"
            className={classes.linkContainer}
          >
            <figure className={classes.linkImage}>
              <img
                className={classes.imgAvatar}
                src="https://d1g6c01s9ssd7h.cloudfront.net/udc/classroom.png"
                alt="Classroom"
              />
            </figure>
            <span className={classes.linkText}>Classroom</span>
          </Button>
          {!props.archived && (
            <Button
              href={props.classroomData.alternateLink}
              target="_blank"
              componnt="a"
              className={classes.linkContainer}
            >
              <figure className={classes.linkImage}>
                <img
                  className={classes.imgAvatar}
                  src="https://d1g6c01s9ssd7h.cloudfront.net/udc/claseVivo.png"
                  alt="Clase en vivo"
                />
              </figure>
              <span className={classes.linkText}>Clase en vivo</span>
            </Button>
          )}
          <Button
            href={`${
              props.classroomData.description
                .split('|')[2]
                .trim()
                .split(' ')[1]
            }`}
            target="_blank"
            componnt="a"
            className={classes.linkContainer}
          >
            <figure className={classes.linkImage}>
              <img
                className={classes.imgAvatar}
                src="https://d1g6c01s9ssd7h.cloudfront.net/udc/clasesAnteriores.png"
                alt="Clases en vivo"
              />
            </figure>
            <span className={classes.linkText}>Clases en vivo</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

SubjectUDCCard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  classroomData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  archived: PropTypes.bool
};

export default SubjectUDCCard;
